"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.AvatarBadge = exports.BasicIndicator = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = require("clsx");
const prefix = 'tk-avatar';
const BasicIndicator = ({ position, variant }) => {
    const classes = (0, clsx_1.clsx)('tk-avatar__badge', `tk-avatar__badge--${position}`, `tk-bg-color--${variant}`);
    return ((0, jsx_runtime_1.jsx)("span", { className: classes, style: { width: '30%', height: '30%', borderRadius: '50%' } }));
};
exports.BasicIndicator = BasicIndicator;
const AvatarBadge = ({ position, children, className }) => {
    const classes = (0, clsx_1.clsx)('tk-avatar__badge', `tk-avatar__badge--${position}`, className);
    return ((0, jsx_runtime_1.jsx)("span", { className: classes, children: children }));
};
exports.AvatarBadge = AvatarBadge;
const Avatar = (_a) => {
    var { size, bordered, children, className, variant } = _a, otherProps = __rest(_a, ["size", "bordered", "children", "className", "variant"]);
    const classes = (0, clsx_1.clsx)(prefix, `${prefix}--${size}`, { [`${prefix}--border`]: bordered }, { [`${prefix}--square`]: variant === 'square' }, className);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes }, otherProps, { children: children })));
};
exports.Avatar = Avatar;
